import type { AnyRouteMatch } from '@tanstack/react-router'

export type RouteMeta = {
  title?: string
  description?: string
  image?: string
  canonical?: string
  noindex?: boolean

  og?: {
    type?: 'website' | 'article' | 'profile' | 'product'
    url?: string
    image?: string
    siteName?: string
    locale?: string
  }

  twitter?: {
    card?: 'summary' | 'summary_large_image'
    image?: string
  }
}

function hasMeta(match: AnyRouteMatch): match is AnyRouteMatch & {
  staticData: { meta: RouteMeta }
} {
  return (
    typeof match.staticData === 'object' &&
    match.staticData !== null &&
    'meta' in match.staticData &&
    typeof (match.staticData as { meta: unknown }).meta === 'object'
  )
}

export function pickMetaFromMatch(match: AnyRouteMatch): RouteMeta | null {
  return hasMeta(match) ? match.staticData.meta : null
}

export function getActiveMeta(matches: AnyRouteMatch[]): RouteMeta | null {
  for (let i = matches.length - 1; i >= 0; i--) {
    const m = pickMetaFromMatch(matches[i])
    if (m) return m
  }
  return null
}
